import { combineReducers } from 'redux';
import * as actions from '../actions';

function visible() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case actions.ACTIVAR:
    case actions.MOSTRAR:
      return true;

    case actions.OCULTAR:
      return false;

    default:
      return state;
  }
}

function activa() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case actions.ACTIVAR:
      return true;

    case actions.DESACTIVAR:
      return false;

    default:
      return state;
  }
}

var nextRecorteId = 0;

function recortes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var newState = void 0;

  switch (action.type) {
    case actions.CREAR_RECORTE:
      newState = [].concat(state);
      newState.push({
        id: nextRecorteId++,
        x: action.x,
        y: action.y,
        w: action.w,
        h: action.h
      });
      return newState;

    case actions.RECORTES:
      newState = [].concat(action.recortes);
      return newState;
    // case actions.MOVER_RECORTE:
    //     newState = state.map( panel => {
    //         if (panel.id === action.id) {
    //             return {
    //                 ...panel,
    //                 x: action.x,
    //                 y: action.y,
    //                 w: action.w,
    //                 h: action.h,                                
    //             }
    //         }
    //         return {...panel}
    //     })
    //     return newState                    
    // case actions.ELIMINAR_RECORTE:
    //     newState = state
    //         .filter( panel => panel.id !== action.id )
    //         .map( panel => ({...panel}) )
    //     return newState

    case actions.RESETEAR:
      return [];

    default:
      return state;
  }
}

var cartulina = combineReducers({
  activa: activa,
  visible: visible,
  recortes: recortes
});
export default cartulina;